import * as React from 'react';
import { connect } from 'react-redux';
import { CLAIM_TYPE_CELLPHONE, CLAIM_TYPE_GLASS, CLAIM_TYPE_NORMAL } from '../../constants/constants';
import { FNOL, DASHBOARD } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import ClaimProgressCard from './ClaimProgressCard';

class MobileClaimProgress extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: FNOL, description: "Claims" }]
        let claimCards = [];
        claimCards = this.props.claimSubmit.fnolStepConfiguration.steps.map((item) => {
            if (item.maxMobileSubSteps > 0 && ((this.props.claimSubmit.claimType === CLAIM_TYPE_NORMAL && item.title !== 'Complete' || this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS || this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE ))) {
                return <ClaimProgressCard id={(item.step === 1 && !this.props.claimSubmit.followUp) ? 4 : 1} title={item.title} subTitle={item.subTitle} nr={item.step} isSelected={this.props.claimSubmit.selectedClaimStep.step === item.step} done={this.props.claimSubmit.selectedClaimStep.step > item.step} stepLabel={item.stepLabel} />
            }
        });
        return (
            <>
                <div className="container-fluid new-page-margins fnol-mobile-progress-container">
                    <div className="new-breadcrumbwrapper breadcrumb-wrapper-fnol-mobile-progress">
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit a claim" />
                    </div>
                    <div className="row new-page-main-row">
                        <div className="col nopa fnol-mobile-progress-container-inner">
                            <div className="fnol-claims-progress-block">
                                <h3>Progress</h3>
                            </div>
                            {claimCards}
                        </div>
                    </div>
                    
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}



export default connect(mapStateToProps)(MobileClaimProgress);